import React from 'react';
import UrbanGallery from './UrbanGallery';
import MiniBio from './MiniBio';

const UrbanSection = () => {
    return (
        <div className="App">
            <UrbanGallery />
            <MiniBio />
        </div>
    );
};

export default UrbanSection;